import { useEffect } from "react";

import { useLanguage } from "../../hooks/use-language";

import styles from "./language-selector.module.css";

export function LanguageSelector() {
  const { language, onLanguageChange } = useLanguage();

  const handleLanguageChange = (e) => {
    onLanguageChange(e.target.id);
    e.currentTarget.blur();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onLanguageChange(e.target.id);
    } else {
      return;
    }
  };

  useEffect(() => {
    let defaultLanguage = window.localStorage.getItem("rcml-lang");
    if (!defaultLanguage) {
      defaultLanguage = window.navigator.language.substring(0, 2);
    }
    onLanguageChange(defaultLanguage);
  }, [onLanguageChange]);

  return (
    <span className={styles.languageSelector}>
      <span
        tabIndex="0"
        id="en"
        className={`${
          language === "en" ? styles.currentLanguage : styles.otherLanguage
        }`}
        onClick={handleLanguageChange}
        onKeyDown={handleKeyDown}
      >
        EN
      </span>
      <span className={styles.otherLanguage}>&nbsp;/&nbsp;</span>
      <span
        tabIndex="0"
        id="de"
        className={`${
          language === "de" ? styles.currentLanguage : styles.otherLanguage
        }`}
        onClick={handleLanguageChange}
        onKeyDown={handleKeyDown}
      >
        DE
      </span>
    </span>
  );
}
